module.exports = __webpack_public_path__ + "img/empty.f7371cf1.png";